import AppMain from "../../components/layout/AppMain";

const DashboardManagementRoutes = {
  path: "/dashboard",
  component: AppMain,
  redirect: "/dashboard/list",
  name: "DashboardManagement",
  meta: {
    title: "Dashboard Management",
    icon: "layout",
    permissions: ["view data"],
  },
  children: [
    {
      path: "list",
      component: () => import("@/views/dashboard/List"),
      name: "DashboardList",
      meta: { title: "Dashboard List" },
    },
    {
      path: "create",
      component: () => import("@/views/dashboard/Create"),
      name: "CreateDashboard",
      meta: { title: "Create Dashboard" },
    },
  ],
};

export default DashboardManagementRoutes;
